import React from 'react';

const Certificate = (props) => {

    const { title, giver, link } = props;

    return(
        <div className="Certificate">
            <h3 className="Certificate__title">{title}</h3>
            <p className="Certificate__giver"><span className="greyOut">{giver}</span></p>
            <a className="Certificate__link" href={link}  target="_blank" rel="noreferrer">Check it out!</a>
        </div>
    )
}

const Colegio = () => {
    return(
        <div className="Edu">
            <h2 className="Edu__title">Boston Highschool</h2>
            <p  className="Edu__date">Jan 2013-Oct 2017</p>
            <strong  className="Edu__degree">Bachelor - Computer Science</strong>
            <p  className="Edu__casaca">
                The education was mostly the very basics of programming. During this time I meddled with C, C++, Arduino and Visual Basic. Here I also learned the basics of HTML and CSS, basically spawning my interest in web development.    
            </p>
            <a  className="Edu__link" href="https://colegiobostonguatemala.com/" target="_blank" rel="noreferrer">Website</a>
        </div>
    )
}

const Universidad = () => {
    return(
        <div className="Edu">
            <h2  className="Edu__title">Del Valle University</h2>
            <p  className="Edu__date">Jan 2018-Present</p>
            <strong  className="Edu__degree">Computer Science Degree</strong>
            <p  className="Edu__casaca">
                The degree focuses on the general teaching of computer science with courses like data structures, databases design and querying, human computer interaction, data mining, algorithm design and analysis and web development frameworks and design.
            </p>
            <a  className="Edu__link" href="https://www.uvg.edu.gt/" target="_blank" rel="noreferrer">Website</a>
        </div>
    )
}

const Certificates = () => {
    return(
        <div  className="Certificates">
            <h2 className="Certificates__title">Certificates</h2>
            <Certificate title="Front-End Web Development with React" giver="Hong Kong University of Science and Technology" link="https://www.coursera.org/account/accomplishments/certificate/RLEHTHKHL254"></Certificate>
            <Certificate title="Server-side Development with NodeJS, Express and MongoDB" giver="Hong Kong University of Science and Technology" link="https://www.coursera.org/account/accomplishments/certificate/Y77XXDFETAGW"></Certificate>
            <Certificate title="Front-End Web UI Frameworks and Tools:Bootstrap 4" giver="Hong Kong University of Science and Technology" link="https://www.coursera.org/account/accomplishments/certificate/VR4N5MYM5SVN"></Certificate>
        </div>
    )
}

const Education = () => {
    return(
        <div className="Education">
            <h2 className="Education__title">Where did I <span className="bullshitGimmick">learn</span> this stuff?</h2>
            <div className="Education__container">
                <Colegio></Colegio>
                <Universidad></Universidad>
                <Certificates></Certificates>
            </div>
        </div>
    )   
}

export default Education;